var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.talk.id
        ? _c("talk-detail", { staticClass: "pb-3", attrs: { talk: _vm.talk } })
        : _vm._e(),
      _vm._v(" "),
      _vm.userHasPermission
        ? _c(
            "div",
            {
              ref: "videowrapper",
              staticClass: "pb-3 row",
              class: { fullscreen: _vm.isFullscreen },
            },
            [
              _c(
                "div",
                { staticClass: "col-8 d-flex align-items-center" },
                [
                  _vm.videoUrl
                    ? [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-sm btn-outline-secondary c-button",
                            on: {
                              click: function ($event) {
                                return _vm.toggleFullscreen()
                              },
                            },
                          },
                          [
                            _vm.isFullscreen
                              ? _c("i", { staticClass: "fas fa-compress" })
                              : _c("i", { staticClass: "fas fa-expand" }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("iframe", {
                          staticStyle: { height: "100%" },
                          attrs: {
                            id: "vimeo-player",
                            src: _vm.videoUrl,
                            width: "100%",
                            frameborder: "0",
                            allow:
                              "autoplay; fullscreen; picture-in-picture; gyroscope; accelerometer",
                            allowfullscreen: "",
                          },
                        }),
                      ]
                    : [
                        _vm.talk.streaming_image
                          ? _c("img", {
                              staticClass: "img-thumbnail",
                              attrs: {
                                src: _vm.talk.streaming_image,
                                alt: _vm.talk.streaming_image,
                              },
                            })
                          : _vm._e(),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-4 d-flex align-items-center" }, [
                _c("div", { staticClass: "d-flex c-relative" }, [
                  _vm.talk.channel_id
                    ? _c(
                        "div",
                        { staticClass: "c-chat-content" },
                        [
                          _c("channel", {
                            attrs: {
                              channelId: _vm.talk.channel_id,
                              "nav-relative": true,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          )
        : _vm.talk.ticket_category
        ? _c("div", { staticClass: "alert alert-danger my-3" }, [
            !_vm.userIsLoggedIn
              ? _c("div", [
                  _vm._v("\n      Sie müssen sich "),
                  _c("a", { attrs: { href: "/accounts/login" } }, [
                    _vm._v("anmelden"),
                  ]),
                  _vm._v(
                    " (login), um das Video und den Session-Chat zu laden!\n    "
                  ),
                ])
              : _c(
                  "div",
                  [
                    _vm.talk.ticket_shop_url
                      ? [
                          _vm._v(
                            "\n        Sie müssen sich für diesen Vortrag "
                          ),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.talk.ticket_shop_url,
                                target: "_blank",
                              },
                            },
                            [_vm._v("registrieren")]
                          ),
                          _vm._v(
                            ", um das Video und den Session-Chat zu sehen!\n        Bitte diese Seite nach der Registrierung neu laden!\n      "
                          ),
                        ]
                      : [
                          _vm._v(
                            "\n        Sie müssen sich für diesen Vortrag registrieren, die Registrierung ist in Kürze verfügbar!\n      "
                          ),
                        ],
                  ],
                  2
                ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.talk && _vm.talk.documents && _vm.talk.documents.length
        ? _c(
            "div",
            { staticClass: "card my-3" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.talk.documents, function (d) {
                return _c("div", { key: d.id, staticClass: "card-body" }, [
                  _c("a", { attrs: { href: d.file } }, [
                    _vm._v(_vm._s(_vm.baseName(d.file))),
                  ]),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card mb-3" }, [
        _c("div", { staticClass: "card-header" }, [
          _vm.talk.registered_mm_user_ids
            ? _c("h4", { staticClass: "mb-0" }, [
                _vm._v("\n          Mitgliederregistrierungen\n        "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.showRegs = !_vm.showRegs
                      },
                    },
                  },
                  [
                    _vm.showRegs
                      ? _c("i", { staticClass: "fa fa-chevron-down" })
                      : _c("i", { staticClass: "fa fa-chevron-right" }),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.showRegs
          ? _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("community-list", {
                  attrs: { talkContentCode: _vm.talk.content_code },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h4", [_vm._v("Downloads")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }